/* eslint-disable react/prop-types */
const PX_PER_UNIT = 58;

/**
 * Marketing Design rulers. Renders a top horizontal ruler and a left vertical ruler
 * that wrap around the canvas (Adobe / InDesign style). Pure CSS / SVG, theme-aware.
 */
export function RulerCorner() {
  return (
    <div
      data-testid="md-ruler-corner"
      style={{
        background: "#242424",
        borderRight: "1px solid rgba(255,255,255,0.18)",
        borderBottom: "1px solid rgba(255,255,255,0.18)",
        gridArea: "corner",
      }}
    />
  );
}

export function TopRuler() {
  return (
    <div
      data-testid="md-top-ruler"
      style={{
        height: 34,
        background: "#242424",
        color: "#f0f0f0",
        borderBottom: "1px solid rgba(255,255,255,0.18)",
        display: "flex",
        alignItems: "flex-end",
        paddingLeft: 12,
        fontSize: 12,
        overflow: "hidden",
        gridArea: "top",
      }}
    >
      <div style={{ display: "flex", gap: PX_PER_UNIT, alignItems: "flex-end", height: "100%" }}>
        {Array.from({ length: 24 }).map((_, i) => (
          <Tick key={i} label={i} orientation="h" />
        ))}
      </div>
    </div>
  );
}

export function LeftRuler() {
  return (
    <div
      data-testid="md-left-ruler"
      style={{
        width: 42,
        background: "#252525",
        color: "#f0f0f0",
        borderRight: "1px solid rgba(255,255,255,0.18)",
        writingMode: "vertical-rl",
        display: "flex",
        alignItems: "center",
        gap: 48,
        paddingTop: 30,
        fontSize: 12,
        gridArea: "left",
      }}
    >
      {Array.from({ length: 18 }).map((_, i) => (
        <span key={i} style={{ color: "#cfcfcf", letterSpacing: "0.06em" }}>{i}</span>
      ))}
    </div>
  );
}

function Tick({ label, orientation }) {
  return (
    <span style={{
      display: "inline-flex",
      flexDirection: "column",
      alignItems: orientation === "h" ? "center" : "flex-end",
      gap: 4, color: "#cfcfcf", letterSpacing: "0.06em",
    }}>
      <span style={{ fontSize: 11 }}>{label}</span>
      <span style={{
        width: 1, height: 6, background: "rgba(255,255,255,0.45)",
      }} />
    </span>
  );
}
